<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="parentData"
            @params="paramsTable"
  >
    <template slot="customButton">
      <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
    </template>
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-lookup :label="$t('Jefe')"
                    :formItemConfig="fiOptions"
                    endpoint="empleados"
                    ref="empleado"
                    :decorator="['id_boss', { rules: [{ required: true, message: 'Valor requerido' }] }]"
          >
          </g-lookup>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Compañía')"
                      :formItemConfig="fiOptions"
                      endpoint="company"
                      :decorator="['id_company', { rules: [{ required: true , message: 'Valor requerido' }] }]">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Oficina')"
                      :formItemConfig="fiOptions"
                      endpoint="offices"
                      :decorator="['office_id', { rules: [{ required: true , message: 'Valor requerido' }] }]">
          </g-dropdown>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        paramsT: {},
        endpointExcel: 'cc_offices_/downloadExcel',
        fileNameExcel: 'Oficinas',
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'cc_offices',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Jefe', dataIndex: 'emp_desc', sorter: true},
              {title: 'Oficina', dataIndex: 'office', sorter: true},
              {title: 'Compañía', dataIndex: 'company', sorter: true},
              {title: 'Centro de costo', dataIndex: 'cc', sorter: true}
            ]
          }
        }
      }
    },
    props: ['id_cc'],
    computed: {
      parentData () {
        return {
          id_cc: this.id_cc
        }
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.id_boss)) {
              this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_boss)
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Cc/CcOffices.vue